"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// We won't bother loading mime-types in the browser.
// tslint:disable-next-line
function lookup() { }
exports.lookup = lookup;
//# sourceMappingURL=mime-types.browser.js.map